module.exports = __webpack_public_path__ + "img/video1-placeholder.788a57c3.jpg";